export default {
	add: 'Add [ES]',
	all: 'All [ES]',
	back: 'back [ES]',
	continue: 'Continúe',
	country: 'País',
	edit: 'Edit [ES]',
	emailAddress: 'Correo Electrónico',
	firstName: 'Nombre',
	important: 'Important [ES]',
	lastName: 'Apellido',
	note: 'Note [ES]',
	notice: 'Notice [ES]',
	notifications: 'Notifications [ES]',
	phoneNumber: 'Número de Teléfono',
	reminder: 'Reminder [ES]',
	save: 'Save [ES]',
	skills: 'Skills [ES]',
	viewAll: 'View All [ES]'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/es-es/global.js